import React from "react";
import { Button, Divider, Flex, Group, Text } from "@mantine/core";
// import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ExportBtn from "../../../../components/exportBtn/exportBtn";
import PageTitle from "../../../../components/Page/PageTitle";
import PageWrapper from "../../../../components/Page/PageWrapper";
import FlagDetailsSkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/FlagDetailsSkeleton";
import FlaggedDataSkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/FlaggedDataSkeleton";
import useFlagsDetailsAdvancedSearch from "./useFlagsDetailsAdvancedSearch.logic";
import classes from "./flagsDetailsAdvancedSearch.module.scss";
// import { routes } from "../../../../utils/vars";
import Details from "./Details";
import FlaggedDataTable from "./FlaggedDataTable";

const FlagsDetailsAdvancedSearch = () => {
  //   const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    id,
    flagData,
    columnsData,
    // backButtonRoute,
    isLoading,
    flagDataError,
    columnsDataError,
  } = useFlagsDetailsAdvancedSearch();

  const idForExport = flagData?.flagDetails?.parentFlagId || id;

  if (isLoading) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.flagDetails")} />
        <FlagDetailsSkeleton />
        <FlaggedDataSkeleton />
      </PageWrapper>
    );
  }

  if (flagDataError) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.flagDetails")} />
        <Flex justify="center" m="md">
          <Button
          //Further discussion needed for the button navigation
          // onClick={() => navigate(backButtonRoute || routes.MONITORING_QUEUE)}
          >
            Back
          </Button>
        </Flex>
      </PageWrapper>
    );
  }

  const { id: flagId, date, name, tenant, data } = flagData?.flagDetails || {};

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.flagDetails")} />
      <Flex
        className={classes["flag-details-advanced-search"]}
        direction="column"
        p="md"
      >
        <Group bg="gray.1" mt="md" p="md" direction="row" justify="flex-start">
          <ExportBtn
            exportUrl={`flag/export?flagId=${idForExport}`}
            method="POST"
            name={`flag-${idForExport}`}
          />
        </Group>
        <Divider />

        <Details
          id={flagId}
          date={date}
          rule={name}
          tenant={tenant}
          author={data}
        />
      </Flex>

      {!columnsDataError && (
        <>
          <Text fw={700} p="md">
            {t("flagDetails.details.flaggedData")}
          </Text>
          <FlaggedDataTable
            columns={columnsData || []}
            rows={flagData?.flaggedData || []}
          />
        </>
      )}
    </PageWrapper>
  );
};

export default FlagsDetailsAdvancedSearch;
